export const getSeparator = ({
	locale = document.documentElement.lang,
	type = 'decimal',
} = {}) => {
	const numberWithGroupAndDecimalSeparator = 1000.1;
	let parts;
	if (!Intl.DateTimeFormat.prototype.formatToParts
		|| 'undefined' === typeof Intl.NumberFormat(locale).formatToParts
	) {
		parts = [{
			type: "decimal",
			value: ".",
		}, {
			type: "group",
			value: ",",
    },
  ];
	} else {
		parts = Intl.NumberFormat(locale).formatToParts(numberWithGroupAndDecimalSeparator);
	}
	return parts.find(part => part.type === type).value;
};

export const isNumeric = number => !isNaN(parseFloat(number)) && isFinite(number);

export default {
	getSeparator,
	isNumeric,
};



// WEBPACK FOOTER //
// /Users/dcsturm/wrk/packages/composer/zd-wp-sage-lib/resources/assets/scripts/util/numbers.js